import { Input, FormProps } from 'antd';
import { useTranslation } from 'react-i18next';

import Form from './Form';

export interface StaffUserFormValues {
  name: string;
  username: string;
  email: string;
}

const StaffUserForm = ({ ...props }: FormProps) => {
  const { t } = useTranslation();

  return (
    <Form<StaffUserFormValues> {...props}>
      <Form.Row>
        <Form.Col span={12}>
          <Form.Item label={t('Nome')} name="name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Form.Col>
        <Form.Col span={12}>
          <Form.Item label={t('Usuário')} name="username" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Form.Col>
      </Form.Row>
      <Form.Row>
        <Form.Col span={12}>
          <Form.Item
            label="E-mail"
            name="email"
            rules={[
              { required: true },
              {
                pattern: /@mindsight.com.br$/,
                message: t('E-mail deve ser do domínio @mindsight.com.br'),
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Form.Col>
      </Form.Row>
    </Form>
  );
};

export default StaffUserForm;
